module.exports = __webpack_public_path__ + "media/images/distilation-tablet-b5d5634239d5506a7985d50eb139fd0f.jpg";